import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import SportCategories from './components/SportCategories';
import HotMatches from './components/HotMatches';
import LatestNews from './components/LatestNews';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <SportCategories />
        <HotMatches />
        <LatestNews />
        <CTASection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}